import React, { useEffect, useState } from 'react';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
export function HeroSection() {
  const [particles, setParticles] = useState<{
    id: number;
    left: string;
    size: number;
    delay: string;
    duration: string;
  }[]>([]);
  useEffect(() => {
    const newParticles = Array.from({
      length: 20
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      size: Math.random() * 4 + 2,
      delay: `${Math.random() * 5}s`,
      duration: `${Math.random() * 10 + 10}s`
    }));
    setParticles(newParticles);
  }, []);
  return <section className="relative w-full min-h-[90vh] bg-gradient-to-b from-navy to-[#1a2f5a] overflow-hidden flex items-center pt-12 pb-20" data-id="element-123">
      {/* Grid Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-124"></div>

      {/* Particles */}
      {particles.map(p => <div key={p.id} className="absolute bottom-0 rounded-full bg-gold animate-particle-float" style={{
      left: p.left,
      width: `${p.size}px`,
      height: `${p.size}px`,
      animationDelay: p.delay,
      animationDuration: p.duration
    }} data-id="element-125" />)}

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-126">
        <div className="flex flex-col items-center text-center animate-fade-in-up" data-id="element-127">
          <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-gold/50 bg-gold/10 backdrop-blur-sm" data-id="element-128">
            <span className="font-montserrat font-bold text-gold text-xs sm:text-sm tracking-wider" data-id="element-129">
              🎓 PARA DOCENTES DE ARGENTINA
            </span>
          </div>

          <h1 className="font-playfair font-bold text-4xl sm:text-5xl lg:text-[58px] leading-[1.1] text-white mb-8" data-id="element-130">
            Dejá de Comprar{' '}
            <span className="text-gold" data-id="element-131">PDFs que No te Sirven</span> para Nada
          </h1>

          {/* Book Image - right after the title */}
          <div className="relative animate-float w-56 sm:w-72 mb-8" style={{
          animationDelay: '0.2s'
        }} data-id="element-132">
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-3/4 h-6 bg-gold/30 blur-xl rounded-full" data-id="element-133"></div>
            <img src="https://cdn.magicpatterns.com/uploads/sMHULadBn8iRhtVVHqE68q/ChatGPT_Image_1_mar_2026,_02_21_01_(1).png" alt="IA Práctica para Docentes - Manual Completo" className="w-full h-auto rounded-lg shadow-2xl drop-shadow-[0_20px_40px_rgba(245,166,35,0.25)]" decoding="sync" fetchPriority="high" width={320} height={400} data-id="element-134" />
          </div>

          <p className="font-inter text-lg sm:text-[22px] leading-relaxed text-[#A8B2D8] mb-10 max-w-[700px]" data-id="element-135">
            Aprendé a Crear tu Propio Material con IA en 10 Minutos. Para
            Siempre. Sin Volver a Gastar un Centavo en Otros.
          </p>

          <div className="flex flex-col items-center" data-id="element-136">
            <a href="#combo-2" className="w-full sm:w-auto inline-block text-center bg-gold text-navy font-montserrat font-extrabold text-base sm:text-lg py-5 px-8 sm:px-12 rounded-lg shadow-[0_8px_32px_rgba(245,166,35,0.4)] hover:scale-105 hover:bg-[#ffb43a] transition-all duration-300 mb-6" data-id="element-137">
              QUIERO MI INDEPENDENCIA DOCENTE →
            </a>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm text-[#A8B2D8] font-inter" data-id="element-138">
              <div className="flex items-center gap-1.5" data-id="element-139">
                <Lock size={16} data-id="element-140" />
                <span data-id="element-141">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-142">
                <ShieldCheck size={16} data-id="element-143" />
                <span data-id="element-144">Garantía de 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-145">
                <Zap size={16} data-id="element-146" />
                <span data-id="element-147">Acceso Inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}